import React from 'react';
import GeneralLayout from '../components/layout/GeneralLayout';
import { graphql } from 'gatsby';
import BlogItem from '../components/BlogItem';
import { Helmet } from 'react-helmet';

export const AllBlogsQuery = graphql`
  query {
    allCosmicjsPosts(sort: { fields: [published_at], order: DESC }) {
      edges {
        node {
          title
          id
          slug
          content
          published_at(formatString: "DD MMMM, YYYY")
          metadata {
            post_author {
              title
            }
            tag {
              title
            }

            description
            main_image {
              url
            }
          }
        }
      }
    }
  }
`;
const Blog = ({ data }) => {
  return (
    <GeneralLayout>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Consult FGC | The Consultant's Couch</title>
        <meta
          name="description"
          content="Consult FGC is a boutique digital marketing, SEO, web design, & web development company. We offer an experienced but personal touch to help meet your digital branding needs & grow your business."
        />
        <link
          rel="icon"
          href="https://consultfgc.netlify.app/static/ConsultFGC_Logo_footer-8b0c6cdcc10d6cc56b61a7b78ed851b7.png"
        />
      </Helmet>
      <div className="bloglist bg-white pt-16 pb-20 px-4 sm:px-6 lg:pt-14 lg:pb-28 lg:px-8">
        <div className="relative max-w-lg mx-auto lg:max-w-7xl">
          <div>
            <h2 className="text-center text-3xl leading-9 tracking-tight font-extrabold text-primary sm:text-5xl sm:leading-10">
              The Consultant's Couch
            </h2>
          </div>
          <div className="mt-12 grid gap-16 border-t border-gray-200 pt-12 lg:grid-cols-2 lg:col-gap-16 lg:row-gap-24">
            {data.allCosmicjsPosts.edges.map(post => {
              console.log(post.node.metadata.tag);

              return (
                <div>
                  <BlogItem
                    key={post.node.id}
                    title={post.node.title}
                    date={post.node.published_at}
                    author={post.node.metadata.post_author.title}
                    description={post.node.metadata.description}
                    slug={'posts/' + post.node.slug}
                    image={post.node.metadata.main_image.url}
                    category={post.node.metadata.tag.map(tag => {
                      return <p className="pr-2">{tag.title + ','}</p>;
                    })}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <svg className="hidden lg:block -mb-20" fill="#161e2e" viewBox="0 0 1440 120">
        <path d="M1440,21.2101911 L1440,120 L0,120 L0,21.2101911 C120,35.0700637 240,42 360,42 C480,42 600,35.0700637 720,21.2101911 C808.32779,12.416393 874.573633,6.87702029 918.737528,4.59207306 C972.491685,1.8109458 1026.24584,0.420382166 1080,0.420382166 C1200,0.420382166 1320,7.35031847 1440,21.2101911 Z" />
      </svg>
    </GeneralLayout>
  );
};

export default Blog;

/*  <p className="text-center mt-3 text-xl leading-7 text-gray-500 sm:mt-4">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque a libero viverra.
            </p>*/
